// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"234":"e9731f37","739":"d7c4c3b0","828":"df60847f","981":"c9043333"}[chunkId] + ".css";
};